module.exports = __webpack_public_path__ + "static/media/farm_5_video1.94b8a94a.png";